import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ProjectListSame = Scrivito.provideObjClass("ProjectListSame", {
  attributes: {
    createNewProject: "string",
    redirectToProjectCreate: ["reference", { only: "ProjectConfigurator" }],
    redirectToProjectItem: ["reference", { only: "ProjectItemSame" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
});

export default ProjectListSame;
